export default __webpack_public_path__ + "static/media/HechterCasual.ffc44150.jpeg";